import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WalkaroundQuestionsComponent } from './pages/walkaround-questions/walkaround-questions.component';
import { WalkaroundQuestionsNewComponent } from './pages/walkaround-questions-new/walkaround-questions-new.component';
import { WalkaroundQuestionsEditComponent } from './pages/walkaround-questions-edit/walkaround-questions-edit.component';
import { AuthGuard } from '../auth/guards/auth.guard';

const routes: Routes = [
  {
    path: 'workshop/walkaround-questions',
    component: WalkaroundQuestionsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'workshop/walkaround-questions/new',
    component: WalkaroundQuestionsNewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'workshop/walkaround-questions/edit/:id',
    component: WalkaroundQuestionsEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WalkaroundQuestionsRoutingModule { }
